export enum KpiType {
  Residential = 'residential',
  Lot = 'lot',
  Photo = 'photo'
}
